import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DelegatingMutableSet$iterator$1Class;
function DelegatingMutableSet$iterator$1() {
  if (DelegatingMutableSet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.g4n_1 = this$0;
        this.f4n_1 = this$0.h4n_1.p1();
      }
      q1() {
        return this.f4n_1.q1();
      }
      r1() {
        return this.g4n_1.i4n_1(this.f4n_1.r1());
      }
      p6() {
        return this.f4n_1.p6();
      }
    }
    initMetadataForClass($);
    DelegatingMutableSet$iterator$1Class = $;
  }
  return DelegatingMutableSet$iterator$1Class;
}
var DelegatingMutableSetClass;
function DelegatingMutableSet() {
  if (DelegatingMutableSetClass === VOID) {
    class $ {
      constructor(delegate, convertTo, convert) {
        this.h4n_1 = delegate;
        this.i4n_1 = convertTo;
        this.j4n_1 = convert;
        this.k4n_1 = this.h4n_1.q2();
      }
      l4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = this.j4n_1(item);
          destination.i2(tmp$ret$2);
        }
        return destination;
      }
      m4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = this.i4n_1(item);
          destination.i2(tmp$ret$2);
        }
        return destination;
      }
      q2() {
        return this.k4n_1;
      }
      n4n(element) {
        return this.h4n_1.i2(this.j4n_1(element));
      }
      i2(element) {
        return this.n4n(element);
      }
      o4n(elements) {
        return this.h4n_1.u2(this.l4n(elements));
      }
      u2(elements) {
        return this.o4n(elements);
      }
      a5() {
        this.h4n_1.a5();
      }
      p4n(element) {
        return this.h4n_1.t2(this.j4n_1(element));
      }
      t2(element) {
        if (!true)
          return false;
        return this.p4n(element);
      }
      q4n(elements) {
        return this.h4n_1.q4(this.l4n(elements));
      }
      q4(elements) {
        return this.q4n(elements);
      }
      n1() {
        return this.h4n_1.n1();
      }
      p1() {
        return new (DelegatingMutableSet$iterator$1())(this);
      }
      hashCode() {
        return hashCode(this.h4n_1);
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !isInterface(other, KtSet());
        }
        if (tmp)
          return false;
        var elements = this.m4n(this.h4n_1);
        var tmp_0;
        if (other.q4(elements)) {
          // Inline function 'kotlin.collections.containsAll' call
          tmp_0 = elements.q4(other);
        } else {
          tmp_0 = false;
        }
        return tmp_0;
      }
      toString() {
        return toString(this.m4n(this.h4n_1));
      }
    }
    initMetadataForClass($, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet()]);
    DelegatingMutableSetClass = $;
  }
  return DelegatingMutableSetClass;
}
//region block: exports
export {
  DelegatingMutableSet as DelegatingMutableSet198sgh8jelkh1,
};
//endregion

//# sourceMappingURL=DelegatingMutableSet.mjs.map
